var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "none",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    d: " M 15.05 8.45 Q 13.65 8.45 12.7 9.6 11.75 10.7 11.75 12.3 11.75 13.85 12.7 14.95 13.65 16.1 15.05 16.1 16.4 16.1 17.35 14.95 18.35 13.85 18.35 12.3 18.35 10.7 17.35 9.6 16.35 8.45 15.05 8.45 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Layer0_0_1_STROKES",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: " M 21.65 14 L 21.65 20.55 24.9 20.55 24.9 17.5 21.65 13.55 Q 21.65 13.75 21.65 14 Z M 21.65 20.55 L 8.45 20.55 5.15 20.55 5.15 17.5 8.45 13.55 Q 8.55 10.65 9.8 8.05 11.05 5.25 13.3 3.45 L 14.1 2.85 Q 15.05 2.2 15.95 2.85 L 16.7 3.45 Q 19 5.25 20.3 8.05 21.5 10.65 21.65 13.55 M 8.45 20.55 L 8.45 14 Q 8.45 13.75 8.45 13.55 M 19.4 24.95 L 19.4 26.2 M 10.65 24.95 L 10.65 26.2 M 15.05 23.7 L 15.05 27.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer0_0_2_STROKES",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    fill: "none",
    d: " M 15.05 16.1 Q 16.4 16.1 17.35 14.95 18.35 13.85 18.35 12.3 18.35 10.7 17.35 9.6 16.35 8.45 15.05 8.45 13.65 8.45 12.7 9.6 11.75 10.7 11.75 12.3 11.75 13.85 12.7 14.95 13.65 16.1 15.05 16.1 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_1_STROKES"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_2_STROKES"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconResources);
export default __webpack_public_path__ + "static/media/icon-resources.1e554b6a1654cddf910d9bba96b2ef4f.svg";
export { ForwardRef as ReactComponent };